



































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditSmokecrib from "./edit-smokecrib.vue";
import CreateSmokecrib from "./create-smokecrib.vue";
class PageSmokecribRequest extends PageRequest {
  //FilterText: string;

  locationName:string;
  yieldly:string;
  year:string;
  grade:string;
  remark:string;

}

class PageCompanyRequest{
  cId:Number;
  fId: Number;
  wId: Number;
  ftId:Number;
}
@Component({
  components: { EditSmokecrib, CreateSmokecrib },
})
export default class Smokecribs extends AbpBase {
  pagerequest: PageSmokecribRequest = new PageSmokecribRequest();
  publicpagerequest: PageSmokecribRequest = new PageSmokecribRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  userName: string;
  cId:Number;
selwarehouselist = [];
    selfloorlist = [];
  get list() {
    return this.$store.state.smokecrib.list;
  }
  get loading() {
    return this.$store.state.smokecrib.loading;
  }
  pageChange(page: number) {
    this.$store.commit("smokecrib/setCurrentPage", page);
    this.getPage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("smokecrib/setPageSize", pagesize);
    this.getPage();
  }
  getsearch(){
     this.$store.state.thequipment.currentPage=1;
    this.getPage();
  }
  async getPage() {
     this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getPaged",
      data: this.pagerequest,
    });
  }

  async getAll() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.smokecrib.pageSize;
  }
  get totalCount() {
    return this.$store.state.smokecrib.totalCount;
  }
  get currentPage() {
    return this.$store.state.smokecrib.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  get company(){
    return this.$store.state.company.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  factorylist(){
    return this.$store.state.factory.list;
  }

  selCompany(value:Number){
    this.pagecompanyrequest.cId = value;
    this.getfactory();
    this.getwarehouse();
      this.getfloor();
       this.getAll();
  }

  columns = [
     {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist();
        //console.log(clist); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房",
      key: "wId",
       render: (h, params) => {
        let wId = params.row.wId;
        let clist = this.warehouselist();
        //console.log(clist); 
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(wId==entry.id){
            wId=entry.wName;
            break;
          }
        }
        return h("span", wId);
      },
    },
    {
      title: "楼层",
      key: "fId",
      render: (h, params) => {
        let fId = params.row.fId;
        let clist = this.floorlist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(fId==entry.id){
            fId=entry.fName;
            break;
          }
        }
        return h("span", fId);
      },
    },
    {
      title: "垛位号",
      key: "locationName",
    },
   
     
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("smokecrib/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",  
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "smokecrib/delete",
                        data: params.row,
                      });
                      await this.getPage();
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
   async getcompany() {
    this.publicpagerequest.maxResultCount = 99;
    this.publicpagerequest.skipCount = 0;
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
      data: this.publicpagerequest,
    });
  }
    selWarehouse(value: Number) {
    this.pagecompanyrequest.wId = value;
    this.getfloor();
  }
  selfactory(value:Number){
    this.pagecompanyrequest.ftId = value;
    if(value != 0){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
      this.selfloorlist = [];
    }
       this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.pagecompanyrequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.pagecompanyrequest,
    });
  }
  selfloor(value:Number){
       this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  selwarehouse(value:Number){
    this.pagecompanyrequest.wId = value;
    if(value != 0 && value != undefined){
      this.getselfloor();
    }
    else{
      this.selfloorlist = [];
    }
       this.$store.state.thequipment.currentPage=1;
       this.getPage();
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.pagecompanyrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    this.selfloorlist =await this.$store.dispatch({
      type: "floor/getAll",
      data: this.pagecompanyrequest,
    });
  }
   async getthreshold(){
      //阈值方案
    //filters
    await this.$store.dispatch({
      type: "threshold/getAll",
      data: this.publicpagerequest,
    });
  }

  created() {
    this.getuserName();
    if (this.userName !== "admin") {
      this.getfactory();
      this.getwarehouse();
      this.getfloor();
      this.getselfloor();
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }else{
      this.getcompany();
    }
    this.getPage();
  }
}
